import React, { Component } from 'react';
import SingleAccordion from './SingleAccordion';

class Sidebar extends Component {

    printMenu() {
        return this.props.menu.map(value => {
            if (value.children.length > 0) {
                return (
                    <SingleAccordion key={value.idService} header={
                        <div className="edb-bar-item edb-button">
                            <img src={value.txIcon} width="26" alt="Ícone" className="edb-margin-small-right" />
                            <span className="adap-sidebar-item-desc">
                                {value.txServiceName}
                                <i className="fas fa-sort-down edb-small"></i>
                            </span>
                            {value.idBadge === 1 && !!this.props.alertas.total && <span className="adap-badge edb-dark-gray edb-margin-small-left">{this.props.alertas.total}</span>}
                        </div>
                    } content={
                        <div className="adap-sub-itens">
                            {value.children.map(item => {
                                return (
                                    <a key={item.idService} href={item.txWebServiceUrl} className="edb-bar-item edb-button adap-gray ">
                                        <i className={item.txIcon + " edb-large edb-margin-small-left"}></i>
                                        <span className="edb-margin-small-left">{item.txServiceName}</span>
                                        {item.idBadge === 2 && !!this.props.alertas.avisos && <span className="adap-badge edb-dark-gray edb-margin-small-left">{this.props.alertas.avisos}</span>}
                                        {item.idBadge === 3 && !!this.props.alertas.notificacoes && <span className="adap-badge edb-dark-gray edb-margin-small-left">{this.props.alertas.notificacoes}</span>}
                                    </a>
                                )
                            })}
                        </div>
                    } />
                )
            } else {
                return (
                    <a key={value.idService} href={value.txWebServiceUrl} className="edb-bar-item edb-button">
                        <img src={value.txIcon} width="26" alt="Ícone" className="edb-margin-small-right" />
                        <span className="adap-sidebar-item-desc">{value.txServiceName}</span>
                        {value.idBadge === 1 && !!this.props.alertas.total && <span className="adap-badge edb-dark-gray edb-margin-small-left">{this.props.alertas.total}</span>}
                    </a>
                )
            }
        })
    }

    render() {
        return (

            <div className={

                (this.props.className || '')
                + " adap-sidebar adap-light-gray edb-sidebar edb-bar-block edb-collapse2 edb-card"}>

                {this.printMenu()}

            </div>

        );
    }
}

export default Sidebar;
